
import { Vue } from 'vue-property-decorator';
export default class Denied extends Vue {
}
